import * as React from "react";
import "./tab.component.css";
import { useEffect, useState } from "react";
import { MessageResponse } from "../../model/MessageResponse";
import {
  IconSearch,
  IconTrash,
  IconEdit,
  IconPlus,
  IconFileImport,
  IconChartArcs,
  IconActivity,
  IconCalendar,
  IconFilter,
  IconHandStop,
} from "@tabler/icons-react";
import {
  MRT_ColumnFiltersState,
  MRT_SortingState,
  MRT_PaginationState,
  MRT_RowSelectionState,
  MRT_ColumnDef,
  useMantineReactTable,
  MantineReactTable,
} from "mantine-react-table";
import {
  ActionIcon,
  Badge,
  Box,
  Button,
  Select,
  Flex,
  Input,
  Menu,
  rem,
  Tooltip,
  Grid,
} from "@mantine/core";
import { _localization } from "../../config/location";
import { OrganizationsModel } from "../../model/OrganizationsModel";
import { modals } from "@mantine/modals";
import OrganizationCreateView from "./OrganizationCreateView";
import OrganizationDeleteView from "./OrganizationDeleteView";
import { isNullOrEmpty } from "../../_base/extension/StringExtension";
import { NotificationExtension } from "../../_base/extension/NotificationExtension";
import OrganizationEditView from "./OrganizationEditView";
import { DatePickerInput } from "@mantine/dates";
import { getBranchSelect } from "../../const/getSelectApi";
import {  pageTable, repositorySign, styleTable } from "../../_base/_const/_constVar";
import { OrganizationModelQuery } from "../../model/OrganizationsModelQuery";
import { useForm } from "@mantine/form";
import { formatDateTransfer } from "../../_base/extension/FormatDate";
import { TblDepartmentModel } from "../../model/TblDepartmentModel";
import { SelectListItem } from "../../model/SelectListItem";
import BreadcrumbLayout1 from "../../_base/component/_layout/_breadcrumb";

const OrganizationsTable = () => {
  //#region  table

  //data and fetching state
  const [data, setData] = useState<TblDepartmentModel[]>([]);
  const [dataSearch, setDataSearch] = useState<TblDepartmentModel[]>([]);

  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);

  //table state
  const [columnFilters, setColumnFilters] = useState<MRT_ColumnFiltersState>(
    []
  );
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState<MRT_SortingState>([]);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 50,
  });
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [selectIds, setSelectIds] = useState<number[] | string[]>([]);

  const [dataBrach, setDataBranch] = useState<any[]>([]);

  const search: any = {
    keySearch: "",
    branchId: 0,
  };
  const form = useForm({
    mode: "uncontrolled",
    initialValues: search,
  });

  const _span = { base: 4, md: 3, lg: 2 };
  const [listEmployee, setListEmployee] = useState<SelectListItem[]>([]);

  const [height, setHeight] = useState(0);

  const headerRef = React.useRef<HTMLDivElement>(null);

  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setOpenedMenu(false);
    let departmentUrl = "/api/v1/Department/get-all";
    let branchUrl = "/api/v1/TblDmInventory/get-select-branch";

    try {
      const departmentResponse = await repositorySign.get<
        MessageResponse<TblDepartmentModel[]>
      >(departmentUrl);
      setData(departmentResponse?.data ?? []);
      setDataSearch(departmentResponse?.data ?? []);
      setRowCount(departmentResponse!.totalCount);
      setSelectIds([]);
      setRowSelection({});
      // const responseDataEmployee = await repositorySign.get<MessageResponse<any>>(
      //   "/api/v1/Employee/get-select"
      // );
      // if (responseDataEmployee && responseDataEmployee.success) {
      //   setListEmployee(responseDataEmployee.data);
      // }
    } catch (error) {
      setIsError(true);
      console.error(error);
      return;
    }
    setIsError(false);
    setIsLoading(false);
    setIsRefetching(false);
  };
  async function getBranch() {
    const responseDataEmployee = await repositorySign.get<MessageResponse<any>>(
      "/api/v1/Employee/get-select"
    );
    if (responseDataEmployee && responseDataEmployee.success) {
      setListEmployee(responseDataEmployee.data);
    }
    // const data = await getBranchSelect();
    // if (data && data.length > 0) setDataBranch(data);
  }

  useEffect(() => {
    fetchData();
  }, [pagination.pageIndex, pagination.pageSize, sorting]);

  useEffect(() => {
    const valuesList = Object.keys(rowSelection);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
  }, [rowSelection]);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (200 + headerHeight));
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  function progessTemplate(props: any): any {
    return (
      <>
        <Tooltip label="Chỉnh sửa thông tin">
          <ActionIcon
            variant="light"
            aria-label="Settings"
            color="cyan"
            onClick={async () => {
              await handleEditDepartment(props.id);
            }}
          >
            <IconEdit size={14} stroke={1.5} />
          </ActionIcon>
        </Tooltip>
        <Tooltip label="Xóa">
          <ActionIcon
            variant="light"
            aria-label="Settings"
            color="red"
            onClick={() => handleDeleteDepartment([props.id])}
          >
            <IconTrash size={14} stroke={1.5} />
          </ActionIcon>
        </Tooltip>
      </>
    );
  }

  const handleCreateDepartment = () => {
    modals.openConfirmModal({
      title: "Thêm mới",
      children: <OrganizationCreateView onClose={fetchData} />,
      size: "auto",
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  const handleSearchData = () => {
    const key = form.getValues().keySearch?.toLowerCase();
    const data = dataSearch.filter((item) => {
      return (
        item.name.toLowerCase().includes(key) ||
        item.code.toLowerCase().includes(key) ||
        item.id.toString().toLowerCase().includes(key)
      );
    });
    setData(data);
  };
  const handleDeleteDepartment = async (ids: number[]) => {
    modals.openConfirmModal({
      title: "Xóa",
      children: (
        <OrganizationDeleteView
          ids={ids}
          onClose={async () => {
            await fetchData();
          }}
        />
      ),
      size: "auto",
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  const handleEditDepartment = async (id: number) => {
    modals.openConfirmModal({
      title: "Chỉnh sửa",
      children: <OrganizationEditView onClose={fetchData} id={id} />,
      size: "auto",
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  const columns = React.useMemo<MRT_ColumnDef<TblDepartmentModel>[]>(
    () => [
      {
        accessorKey: "id",
        header: "Id",
      },
      {
        accessorKey: "code",
        header: "Mã đơn vị",
      },
      {
        accessorKey: "name",
        header: "Tên đơn vị",
      },
      {
        accessorKey: "type",
        header: "Loại",
        Cell: ({ renderedCellValue }) => {
          let text = "Không xác định";
          let color = "gray"; // Màu mặc định nếu không xác định

          switch (renderedCellValue) {
            case 1:
              text = "Công ty mẹ";
              color = "blue"; // Màu cho Công ty mẹ
              break;
            case 3:
              text = "Phòng ban";
              color = "green"; // Màu cho Phòng ban
              break;
            case 2:
              text = "	Đơn vị thành viên";
              color = "orange"; // Màu cho Thành viên
              break;
          }

          return (
            <Badge color={color} variant="light" radius="sm">
              {text}
            </Badge>
          );
        },
      },

      {
        accessorKey: "status",
        header: "Trạng thái",
        Cell: ({ renderedCellValue, row }) => (
          <>
            <Badge
              color={getColorStatus(Boolean(renderedCellValue)).color}
              variant="light"
              radius={"sm"}
            >
              {getColorStatus(Boolean(renderedCellValue)).text}
            </Badge>
          </>
        ),
      },
      // {
      //   accessorKey: "createBy",
      //   header: "Người tạo",
      //   Cell: ({ renderedCellValue, row }) => {
      //     console.log(renderedCellValue);
      //     const toLocations = listEmployee?.find((item) => {
      //       return item.value === String(renderedCellValue);
      //     })?.text;

      //     return <>{toLocations}</>;
      //   },
      // },
      // {
      //   accessorKey: "createDate",
      //   header: "Ngày tạo",
      //   Cell: ({ renderedCellValue }: any) => (
      //     <>{formatDateTransfer(renderedCellValue)}</>
      //   ),
      // },
      // {
      //   accessorKey: "lastUpdateBy",
      //   header: "Người cập nhật",
      //   Cell: ({ renderedCellValue, row }) => {
      //     console.log(renderedCellValue);
      //     const toLocations = listEmployee?.find((item) => {
      //       return item.value === String(renderedCellValue);
      //     })?.text;

      //     return <>{toLocations}</>;
      //   },
      // },
      // {
      //   accessorKey: "lastUpdateDate",
      //   header: "Ngày cập nhật",
      //   Cell: ({ renderedCellValue }: any) => (
      //     <>{formatDateTransfer(renderedCellValue)}</>
      //   ),
      // },
      {
        accessorKey: "action",
        header: "Thao tác",
        size: 50,
        Cell: ({ renderedCellValue, row }) => (
          <Box
            style={{
              display: "flex",
              alignItems: "center",
              gap: "16px",
            }}
          >
            {progessTemplate(row.original)}
          </Box>
        ),
      },
    ],
    []
  );

  function getColorStatus(status: boolean) {
    return status
      ? {
          text: "Hoạt động",
          color: "green",
        }
      : {
          text: "Không hoạt động",
          color: "red",
        };
  }
  const [openedMenu, setOpenedMenu] = useState(true);
  React.useEffect(() => {
    //do something when the row selection changes...
    console.info({ rowSelection });
  }, [rowSelection]);

  const table = useMantineReactTable({
    columns,
    data,
    positionToolbarAlertBanner: "bottom",
    //add custom action buttons to top-left of top toolbar
    renderTopToolbarCustomActions: ({ table }) => <></>,
    renderToolbarInternalActions: ({ table }) => <></>,
    mantineTopToolbarProps: {
      style: {
        display: "none",
      },
    },
    localization: _localization,
    enableRowSelection: true,
    getRowId: (row) => row.id?.toString(),
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        // left: [
        //   "STT",
        //   "mrt-row-select",
        //   "mrt-row-expand",
        //   "orderNumber",
        //   "orderStatus",
        // ],
        // right: ["action"],
      },
      columnVisibility: { id: false },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    // manualFiltering: true,
    // manualPagination: true,
    // manualSorting: true,
    rowCount,
    // onColumnFiltersChange: setColumnFilters,
    // onGlobalFilterChange: setGlobalFilter,
    // onPaginationChange: setPagination,
    // onSortingChange: setSorting,
    mantineTableBodyCellProps: ({ row }) => ({
      style: styleTable,
    }),
    state: {
      // columnFilters,
      // globalFilter,
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading, //loading for the first time with no data
      // sorting,
      rowSelection,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: pageTable,
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    displayColumnDefOptions: {
      "mrt-row-select": {
        size: 1,
      },
      "mrt-row-expand": {
        size: 1,
      },
    },
  });

  //#endregion
  return (
    // <>
    //     <div className="mt-5">
    //         <MantineReactTable table={table} />
    //     </div>
    // </>
    <>
      <div
        style={{ border: "1px solid #dee2e6", padding: "10px" }}
        ref={headerRef}
      >
        <Flex justify="space-between" align="center">
          <BreadcrumbLayout1 />
          <Flex justify={"end"}>
            <Button
              leftSection={<IconPlus size={14} />}
              variant="outline"
              mr={"xs"}
              onClick={handleCreateDepartment}
            >
              Thêm mới
            </Button>

            <Button
              leftSection={<IconTrash size={14} />}
              color="red"
              variant="outline"
              mr={"xs"}
              onClick={async () => {
                await handleDeleteDepartment(selectIds as number[]);
              }}
              disabled={selectIds.length < 1}
            >
              Xóa
            </Button>
          </Flex>
        </Flex>
        <form>
          <Grid>
            <Grid.Col span={_span}>
              <Input.Wrapper label="Từ khóa">
                <Input
                  leftSection={<IconSearch color="#15aabf" />}
                  placeholder="Nhập từ khóa"
                  key={form.key(`keySearch`)}
                  {...form.getInputProps("keySearch")}
                />
              </Input.Wrapper>
            </Grid.Col>
            {/* <Grid.Col span={_span}>
              <Select
                label="Chí nhánh"
                placeholder="Chọn..."
                clearable
                searchable
                limit={30}
                comboboxProps={{
                  transitionProps: {
                    transition: "pop",
                    duration: 200,
                  },
                }}
                data={dataBrach.map((item) => {
                  return {
                    label: item.text ?? "",
                    value: String(item.value ?? ""),
                  };
                })}
                nothingFoundMessage="Dữ liệu không có !"
                key={form.key(`branchId`)}
                {...form.getInputProps("branchId")}
              />
            </Grid.Col> */}
            <Grid.Col span={_span}>
              <Button
                mt={"25px"}
                leftSection={<IconSearch size={14} />}
                color="blue"
                variant="outline"
                onClick={handleSearchData}
              >
                Tìm kiếm
              </Button>
            </Grid.Col>
          </Grid>
        </form>
      </div>
      <div className="mt-5">
        <MantineReactTable table={table} />
      </div>
    </>
  );
};
export default OrganizationsTable;
